<template>
  <ca-select
    v-if="isEsocialDisabledStatus(esocialStatus)"
    v-model="esocialStatus"
    disabled>
    <ca-option
      v-for="status in ESOCIAL_DISABLED_STATUS"
      :key="status.name"
      :value="status.name">
      {{ status.description }}
    </ca-option>
  </ca-select>
  <ca-select
    v-else
    v-model="esocialStatus"
    @change="onChange">
    <ca-option
      v-for="status in misc.esocialStatus.default"
      :key="status.name"
      :value="status.name">
      {{ status.description }}
    </ca-option>
  </ca-select>
</template>

<script>
import { ESOCIAL_DISABLED_STATUS } from 'accountant/esocial/contants';
import { isEsocialDisabledStatus } from 'accountant/esocial/esocialService';

export default {
  name: 'EsocialTableSelect',
  props: {
    value: String,
    object: Object,
  },
  data() {
    return {
      esocialStatus: this.value,
      ESOCIAL_DISABLED_STATUS,
    };
  },
  computed: {
    misc() {
      return this.$store.state.misc;
    },
  },
  created() {
    this.$store.dispatch('misc/getEsocialStatus');
  },
  methods: {
    isEsocialDisabledStatus,
    onChange(esocialStatus) {
      this.$emit('input', esocialStatus);
      this.$emit('change', esocialStatus, this.object);
    },
  },
};
</script>
